(() => {
  const SELECTOR = '[data-yt-facade]';
  let connectionsWarmed = false;

  function addResourceHint(rel, href) {
    if (!href || document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) {
      return;
    }

    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;

    if (rel === 'preconnect') {
      link.crossOrigin = '';
    }

    document.head.appendChild(link);
  }

  function warmConnections() {
    if (connectionsWarmed) return;
    connectionsWarmed = true;

    addResourceHint('preconnect', 'https://www.youtube-nocookie.com');
    addResourceHint('preconnect', 'https://www.youtube.com');
    addResourceHint('preconnect', 'https://i.ytimg.com');

    addResourceHint('dns-prefetch', 'https://www.youtube-nocookie.com');
    addResourceHint('dns-prefetch', 'https://www.youtube.com');
    addResourceHint('dns-prefetch', 'https://i.ytimg.com');
  }

  function buildIframe(root) {
    if (!root || root.dataset.loaded === 'true') return;

    const videoId = root.dataset.videoId;
    const title = root.dataset.title || 'YouTube video';
    const start = parseInt(root.dataset.start || '0', 10);

    if (!videoId) return;

    warmConnections();

    const params = new URLSearchParams({
      autoplay: '1',
      playsinline: '1',
      rel: '0',
      modestbranding: '1'
    });

    if (!Number.isNaN(start) && start > 0) {
      params.set('start', String(start));
    }

    const iframe = document.createElement('iframe');
    iframe.className = 'yt-video-grid__iframe';
    iframe.title = title;
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

    while (root.firstChild) {
      root.removeChild(root.firstChild);
    }

    root.appendChild(iframe);
    root.dataset.loaded = 'true';
    root.classList.add('is-loaded');
  }

  document.addEventListener(
    'pointerenter',
    (event) => {
      if (event.target.closest('.yt-video-grid__poster')) {
        warmConnections();
      }
    },
    true
  );

  document.addEventListener('focusin', (event) => {
    if (event.target.closest('.yt-video-grid__poster')) {
      warmConnections();
    }
  });

  document.addEventListener(
    'touchstart',
    (event) => {
      if (event.target.closest('.yt-video-grid__poster')) {
        warmConnections();
      }
    },
    { passive: true, once: true }
  );

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.yt-video-grid__poster');
    if (!trigger) return;

    const root = trigger.closest(SELECTOR);
    buildIframe(root);
  });
})();